import { actionGenerator } from '@mopla/utils';

export enum EFeedbacksActionTypes {
	FetchMoplaLegFeedback = '[Feedbacks] Fetch Mopla leg feedback',
	FetchMoplaLegFeedbackResult = '[Feedbacks] Fetch Mopla leg feedback result',
	WipeMoplaFeedbacksData = '[Feedbacks] Wipe Mopla feedbacks data',
}

export const fetchMoplaLegFeedback = actionGenerator<
	EFeedbacksActionTypes.FetchMoplaLegFeedback,
	{ moplaLegId: string }
>(EFeedbacksActionTypes.FetchMoplaLegFeedback);

export const fetchMoplaLegFeedbackResult =
	actionGenerator<EFeedbacksActionTypes.FetchMoplaLegFeedbackResult>(
		EFeedbacksActionTypes.FetchMoplaLegFeedbackResult
	);

export const wipeMoplaFeedbacksData =
	actionGenerator<EFeedbacksActionTypes.WipeMoplaFeedbacksData>(
		EFeedbacksActionTypes.WipeMoplaFeedbacksData
	);

export type TFetchMoplaLegFeedbackAction = ReturnType<
	typeof fetchMoplaLegFeedback
>;
